import React from 'react';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import * as styles from './quick-links.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var AllhomesFooterQuickLinks = _ref => {
  var _ref$quickLinks = _ref.quickLinks,
    quickLinks = _ref$quickLinks === void 0 ? [] : _ref$quickLinks;
  var _useAllhomesApi = useAllhomesApi(),
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl;
  var renderQuickLinks = items => items.map(item => ___EmotionJSX("li", {
    key: item.text
  }, ___EmotionJSX("a", {
    css: styles.item,
    href: getAbsoluteUrl(item.href)
  }, item.text)));
  var renderColumns = columns => columns.map(column => ___EmotionJSX("li", {
    key: column.heading,
    css: columns.length > 5 ? styles.column : styles.columnSpaced
  }, ___EmotionJSX("h3", {
    css: styles.heading
  }, column.heading), ___EmotionJSX("ul", {
    css: styles.list
  }, renderQuickLinks(column.items))));
  return ___EmotionJSX("div", {
    css: styles.quickLinks
  }, ___EmotionJSX("div", {
    css: styles.innerWrap
  }, ___EmotionJSX("ul", {
    css: styles.innerWrapList
  }, renderColumns(quickLinks))));
};